module.exports = __webpack_public_path__ + "static/media/down_arrow_black.a0e27654.svg";